import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-[#FEEECE] text-black shadow-md">
      <div className="container mx-auto flex justify-between items-center px-6 py-4">
        <h1 className="text-2xl font-bold text-gray-900">Escritório de Advocacia</h1>
        
        <button className="md:hidden text-gray-900" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>

        <ul className={`md:flex md:space-x-6 text-lg ${isOpen ? "block" : "hidden"} md:block`}>
          <li>
            <Link to="/" className="block p-2 hover:text-gray-600">Home</Link>
          </li>
          <li>
            <Link to="/sobre" className="block p-2 hover:text-gray-600">Sobre</Link>
          </li>
          <li>
            <Link to="/servicos" className="block p-2 hover:text-gray-600">Serviços</Link>
          </li>
          <li>
            <Link to="/contato" className="block p-2 hover:text-gray-600">Contato</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
